import { useDefaultClient } from "~/hooks/useDefaultClient"
import { usePrinticularApi } from "~/hooks/usePrinticularApi"
import { VNZService } from "../service/VNZService"

export const useVNZService = () => {
  const { client } = useDefaultClient()
  const printicularApi = usePrinticularApi()

  const verizonApiUrl = client?.verizonApiUrl || ""
  const verizonAuthUrl = client?.verizonAuthUrl || ""
  const verizonCloudFrontProxyUrl = client?.verizonCloudFrontProxyUrl || ""

  return new VNZService(
    verizonApiUrl,
    verizonAuthUrl,
    verizonCloudFrontProxyUrl,
    printicularApi
  )
}
